import { BaseFiltroPagDTO, IdNomeDTO } from './base-dto';

export class TerapiaListItemDTO {
  id: Number;
  codigo: string;
  nome: string;
  ativo: boolean;
  criadoPor: string;
  dataCriacao: Date;
}

export class IdadePesoQtdeTerapiaParmDTO {
  idade: Number;
  tipoIdade: String;
  pesoKg: Number;
  quantidade: Number;
}

export class IdadePesoQtdeTerapiaDTO extends IdadePesoQtdeTerapiaParmDTO {
  idUnidadeMedida: Number;
  nomeUnidadeMedida: string;
}

export enum TipoIdade {
  D,
  A,
}

export class TerapiaParmDTO {
  idTerapia: Number;
  codTerapia: string;
  nomeTerapia: string;
  ativo: boolean;
  enteralObjetivoCalorico: Number;
  enteralFatorTermogenese: Number;
  enteralFatorSuspensao: Number;
  produtos: ProdutoTerapiaParmDTO[];
  volumes: VolumeTerapiaParmDTO[];
}

export class ProdutoTerapiaParmDTO {
  idProduto: Number;
  quantidades: IdadePesoQtdeTerapiaParmDTO[];
  idUnidadeMedida: Number;
}

export class VolumeTerapiaParmDTO {
  idade: Number;
  tipoIdade: String;
  pesoKg: Number;
  quantidade: Number;
  idUnidadeMedida: Number;
}

export class VolumeTerapiaDTO extends VolumeTerapiaParmDTO {
  nomeUnidadeMedida: string;
}

export class TerapiaDetalheDTO {
  id: Number;
  codTerapia: string;
  nomeTerapia: string;
  ativo: boolean;
  enteralObjetivoCalorico: Number;
  enteralFatorTermogenese: Number;
  enteralFatorSuspensao: Number;
  produtos: ProdutoTerapiaDTO[];
  volumes: VolumeTerapiaDTO[];
}

export class ProdutoTerapiaDTO extends ProdutoTerapiaParmDTO {
  nomeProduto: string;
  nomeUnidadeMedida: string;
  medidas: IdNomeDTO[];
}

export class FiltroTerapiaParmDTO extends BaseFiltroPagDTO {
  nome: string;
  idUnidade: Number;
  ativo: boolean;
}

export class TerapiaUsoProdutoDTO extends IdadePesoQtdeTerapiaDTO {
  idProduto: Number;
  idQuantidade: Number;
  nomeProduto: string;
  encontrado: boolean;
}

export class TerapiaUsoDTO {
  idTerapia: Number;
  idPaciente: Number;
  idUnidade: Number;
  podeUsar: boolean;
  podeAlterarQuantidades: boolean;
  todosProdutosOk: boolean;

  produtos: Array<TerapiaUsoProdutoDTO>;
  volume: VolumeTerapiaDTO;
  agua: Number;

  viaAdministracao: string;
}

export class ProdutoTerapiaSimplificadaParmDTO {
  idProduto: Number;
  idUnidadeMedida: Number;
  quantidades: QtdeProdutoTerapiaSimplificadaParmDTO[];
}

export class QtdeProdutoTerapiaSimplificadaParmDTO {
  quantidade: Number;
  diasTN: string;
}

export class ProdutoTerapiaSimplificadaDTO extends ProdutoTerapiaSimplificadaParmDTO {
  nomeProduto: string;
  nomeUnidadeMedida: string;
}


export class TerapiaSimplificadaParmDTO {
  id: Number;
  codigo: string;
  nome: string;
  ativo: boolean;
  npt: string;
  viaAdministracao: string;
  ofertaNutricional: string;
  idEstadoClinico: number;
  idsSituacoesClinicas: number[];
  produtos: ProdutoTerapiaSimplificadaParmDTO[];
  idVolumeUnidade: number;
  volumeQuantidade: number;
  idsUnidadesClientes: number[];
}

export class TerapiaSimplificadaDetalheDTO extends TerapiaSimplificadaParmDTO {

}

export class UnidadesAcessosProdutosParmDTO {
  idsUnidades: Number[];
  idsProdutos: Number[];
}

export class UnidadeAcessoProdutosResult {
  unidade: IdNomeDTO;
  produtosNaoDisponiveis: IdNomeDTO[];
}

export class FiltroTerapiaSimplParmDTO extends BaseFiltroPagDTO {
  nome: string;
  idUnidade: Number;
  ativo: boolean;
  npt: string;
  viaAdministracao: string;
  diasTN: string;
  ofertaNutricional: string;
  idEstadoClinico: number;
  idsSituacoesClinicas: number[];
}

export class UsoTerapiaSimplifFiltro {
  idUnidade: number;
  npt: string;
  viaAdministracao: string;
  diasTN: string;
  ofertaNutricional: string;
  idEstadoClinico: number;
  idsSituacoesClinicas: number[];
}

export class FiltroSituacaoClinicaDTO {
  idUnidade: number;
  viaAdministracao: string;
  idEstadoClinico: number;
  idsSituacoesClinicas: number[];
}
